import React, { useEffect, useState } from "react";
import { getAuthHeader } from "../../api/authToken.js";
import axios from "axios";
import "../../styles/App.css";

const ViolationsPage = () => {
  const [violations, setViolations] = useState([]);
  const [students, setStudents] = useState([]); 
  const [editingViolation, setEditingViolation] = useState(null);
  const [searchQuery, setSearchQuery] = useState(""); 
  const [form, setForm] = useState({
    student_id: "",
    date: "",
    reason: "",
    file_url: "",
    type: "act",
  });
  const API = process.env.REACT_APP_API_BASE;

  useEffect(() => {
    fetchViolations();
    fetchStudents();
  }, []);

  const fetchViolations = async () => {
    try {
      const res = await axios.get(`${API}/api/admin-violations`, {
        headers: { Authorization: getAuthHeader() },
      });
      setViolations(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchStudents = async () => {
    try {
      const res = await axios.get(`${API}/api/students`, {
        headers: { Authorization: getAuthHeader() },
      });
      setStudents(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Ви впевнені, що хочете видалити порушення?"
    );
    if (!confirmDelete) return;

    try {
      await axios.delete(`${API}/api/admin-violations/${id}`, {
        headers: { Authorization: getAuthHeader() },
      });
      fetchViolations();
    } catch (err) {
      console.error(err);
    }
  };

  const handleEdit = (violation) => {
    setEditingViolation(violation.id);
    setForm({
      ...violation,
      date: violation.date ? violation.date.split("T")[0] : "", // Обрізаємо час
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingViolation) {
        await axios.put(`${API}/api/admin-violations/${editingViolation}`, form, {
          headers: { Authorization: getAuthHeader() },
        });
      } else {
        await axios.post(`${API}/api/admin-violations`, form, {
          headers: { Authorization: getAuthHeader() },
        });
      }
      setEditingViolation(null);
      setForm({
        student_id: "",
        date: "",
        reason: "",
        file_url: "",
        type: "act",
      });
      fetchViolations();
    } catch (err) {
      console.error(err);
    }
  };

  const filteredViolations = violations.filter((v) =>
    `${students.find((s) => s.id === v.student_id)?.pib || v.student_id} ${
      v.reason
    } ${v.date}`
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  return (
    <div className="page-container">
      <h3 className="header-content-title">
        Якщо тут пусто - сплив термін JWT-токена, необхідно перезайти в
        обліковий запис.
      </h3>

      <input
        className="search-input"
        type="text"
        placeholder="Пошук за ПІБ, описом або датою..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />

      <form onSubmit={handleSubmit} className="header-content">
        <select
          className="header-content-input"
          value={form.student_id}
          onChange={(e) => setForm({ ...form, student_id: e.target.value })}
          required
        >
          <option value="">Оберіть студента</option>
          {students.map((student) => (
            <option key={student.id} value={student.id}>
              {student.pib}
            </option>
          ))}
        </select>

        <input
          className="header-content-input"
          type="date"
          value={form.date}
          onChange={(e) => setForm({ ...form, date: e.target.value })}
          required
        />
        <textarea
          className="header-content-input"
          style={{ height: "18px" }}
          placeholder="Причина"
          value={form.reason}
          onChange={(e) => setForm({ ...form, reason: e.target.value })}
          required
        />
        <input
          className="header-content-input"
          type="text"
          placeholder="Посилання на файл"
          value={form.file_url}
          onChange={(e) => setForm({ ...form, file_url: e.target.value })}
        />
        <select
          className="header-content-input"
          value={form.type}
          onChange={(e) => setForm({ ...form, type: e.target.value })}
        >
          <option value="act">Акт</option>
          <option value="warning">Попередження</option>
        </select>
        <button type="submit" className="admin-add-button">
          {editingViolation ? "Оновити" : "Додати"}
        </button>
      </form>

      <table cellPadding="5" className="table">
        <thead>
          <tr>
            <th className="table-header">#</th>
            <th className="table-header">Студент</th>
            <th className="table-header">Дата</th>
            <th className="table-header">Причина</th>
            <th className="table-header">Тип</th>
            <th className="table-header">Дії</th>
          </tr>
        </thead>
        <tbody>
          {filteredViolations.map((v, index) => (
            <tr key={v.id}>
              <td className="table-content">{index + 1}</td>
              <td className="table-content">
                {students.find((s) => s.id === v.student_id)?.pib ||
                  v.student_id}
              </td>
              <td className="table-content">{v.date}</td>
              <td className="table-content">{v.reason}</td>
              <td className="table-content">
                {v.type === "act" ? "Акт" : "Попередження"}
              </td>
              <td className="table-content">
                <div className="admin-button-container">
                  <button
                    className="admin-edit-button"
                    onClick={() => handleEdit(v)}
                  >
                    ✏️
                  </button>
                  <button
                    className="admin-edit-button"
                    onClick={() => handleDelete(v.id)}
                  >
                    🗑️
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ViolationsPage;
